// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__adgGC","insightsList":"newBusinessInsightsMenu_insightsList__3iQll","active":"newBusinessInsightsMenu_active__8fLMK"};